import hasElementAttribute from './has-element-attribute';
import isEmpty from './is-empty';

export default {
  hasElementAttribute,
  isEmpty,
};
